export default __webpack_public_path__ + "static/media/donate_idea.0478c1c7.svg";